import type { FaireProductEntity } from "../../entity_types/product";

export const p_yecgvaauy3: FaireProductEntity = {
  token: "p_yecgvaauy3",
  type: "product",
  name: "Maine Root Blueberry 12oz Glass (24 Pack)",
  brandToken: "b_sc6x2al4xm",
  brandName: "Maine Root Craft Soda",
  imageUrl: "https://cdn.faire.com/fastly/86f95937b23a6acee687e26f4c8ac285d1140643e44512a2c78786664018ffa2.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b72432396d69c61d4a1cf8a3725e3a4709bdd8f02267a541bbd70afb1a15068.png",
    "https://cdn.faire.com/fastly/d52be8bbf3461e9032e7d4aa7715b20d8ef9dbe429dc88c07b563f6bfd3c76fe.webp",
    "https://cdn.faire.com/fastly/9356558e6deddbab36da605e2ce4841a25a77b152698e6ee07882c7748c01f7d.webp",
    "https://cdn.faire.com/fastly/5744040438a8f78ee273af655306de265530d30bf1c739fc5155bf67710c16d2.webp",
    "https://cdn.faire.com/fastly/d93f6fd27cbdc60ed5e82934424007f240733715d2ac5666894f73143452ae46.webp"
  ],
  priceDollars: 2.88,
  description: "Maine Root Blueberry Soda 12oz Glass is a delightful beverage that captures the essence of fresh blueberries in every sip. Crafted by Maine Root, this blueberry soda is a true gem among soda enthusiasts. Its deep blueberry flavor is complemented by the soda's crisp carbonation, making it a refreshing choice for soda lovers. Whether you're craving the unique taste of blueberry soda or searching for a tasty and caffeine-free option, this Maine Root creation is the answer. \n\nMaine Root Blueberry Soda boasts a clean and natural ingredient list, making it a top pick for those looking for a healthier soda alternative. The carefully selected ingredients and thoughtful craftsmanship result in a soda that captures the essence of Maine's blueberries. If you're on the hunt for this distinctive soda near you, check out local stores or beverage shops that carry Maine Root products. With its enticing blueberry flavor, Maine Root Blueberry Soda is a delicious choice for anyone seeking a refreshing and unique soda experience. Cheers to the taste of Maine in every bottle! ",
  tags: [],
  msrpDollars: 5.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:07.843Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
